import { apiClient } from "./apiClient";
import { adminApi } from "./adminApi";

/**
 * `maintenanceMode` reuses the real POST /management/maintenance-mode
 * (api/functions/admin.py), which already persists to dbo.AppConfig.
 *
 * GAP: announcements, the public status page, scheduled downtime, and the
 * API replay/debug console have no backend at all. dbo.AppConfig (V024)
 * could hold `system_announcement` the same MERGE-upsert way
 * maintenance_mode already works, which would make announcements cheap to
 * add; a real public status page additionally needs an unauthenticated
 * route (outside this admin app's auth-gated shell entirely, more like
 * status.yourdomain.com being a separate static/CDN-hosted surface fed by a
 * small public read-only endpoint) rather than living inside this SPA. The
 * API replay/debug console is the biggest gap -- safely replaying a
 * captured request against production needs careful design (which
 * endpoints are replay-safe/idempotent, whether it re-runs against real
 * data or a sandboxed copy) before it should exist at all.
 */
export const systemApi = {
  setMaintenanceMode: (enabled, message) => adminApi.setMaintenanceMode(enabled, message),
  getMaintenanceMode: () => apiClient.get("/management/maintenance-mode").then((r) => r.data),

  listAnnouncements: () => apiClient.get("/management/announcements").then((r) => r.data),
  createAnnouncement: (message, severity, expiresAt) =>
    apiClient.post("/management/announcements", { message, severity, expires_at: expiresAt }).then((r) => r.data),

  scheduleDowntime: (startsAt, endsAt, message) =>
    apiClient.post("/management/scheduled-downtime", { starts_at: startsAt, ends_at: endsAt, message }).then((r) => r.data),
  listScheduledDowntime: () => apiClient.get("/management/scheduled-downtime").then((r) => r.data),

  replayRequest: (requestId) => apiClient.post(`/management/debug/replay/${requestId}`).then((r) => r.data),
};
